import ForgotPasswordForm from '../../components/auth/ForgotPasswordForm';
import './ForgotPasswordPage.css';

const ForgotPasswordPage = () => {
  return (
    <div className="forgot-password-page">
      <div className="forgot-password-page__container">
        <div className="forgot-password-page__content">
          <div className="forgot-password-page__logo">
            🚗
          </div>
          <h1 className="forgot-password-page__title">瑋瑋車業</h1>
          <ForgotPasswordForm />
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
